import React, { Component } from 'react';
import logo from './logo.svg';
import css from './App.css';
import CSSModule from 'react-css-modules';
import { connect } from 'react-redux'
import { getUserInfo, getPoints, getClassList } from '../actions';
import Header from './header';
import Footer from './footer';

class App extends Component {
	constructor(props){
		super(props);
		if( !props.user.hasOwnProperty('id') ) props.getUserInfo();
		props.getClassList();
		this.state = {};
	}
	componentWillReceiveProps(nextProps) {
		if( this.props.user !== nextProps.user && nextProps.user) {
			//console.log(nextProps.user);
			nextProps.getPoints({user_id: nextProps.user.id});
		}
		
	}
	
	render() {
		return (
			<div styleName="viewWrapper">
				<Header path={this.props.router.location.pathname}/>
				<div styleName="container">
					{ this.props.children }
				</div>
				<Footer/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return { 
		user: state.data.user 
	};
}

export default connect(mapStateToProps, { getUserInfo, getPoints, getClassList })(CSSModule(App,css));



/** WEBPACK FOOTER **
 ** ./src/container/App.js
 **/